module.exports = __webpack_public_path__ + "media/images/USA-matrimony-banner2-22daca9e928fd2c046b2b4e290a3b4fb.jpg";